import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
}));

const tileData = [
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: '칸타타프리미엄라떼',
        author: '800원',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml_2.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },
    {
        img: require('../images/snacks/칸타타프리미엄라떼175ml.png'),
        title: 'Image',
        author: 'author',
    },

];

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     author: 'author',
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */
export default function SnackMenu() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <GridList cellHeight={200} className={classes.gridList} cols={3.5}>
                {tileData.map(tile => (
                    <GridListTile key={tile.img}>
                        <img src={tile.img} alt={tile.title} style={{ width: 200, marginLeft: 2 }} />
                        <GridListTileBar
                            title={tile.author}
                            subtitle={tile.title}
                    />
                    </GridListTile>
                ))}
            </GridList>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/SnackMenu.js